export default () => (
    <div style={{width: "100%", height: "100%", position: "fixed", top: 0, left: 0, background: "rgba(0, 0, 0, 0.4)",zIndex:"2"}}>
        Loading...
    </div>
)